import React, { useEffect, useMemo, useRef, useState } from "react";
import "../../App.css";
import api from "../../api/client";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Typography,
  TextField,
  InputAdornment,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Divider,
  Autocomplete,
  Checkbox,
  Chip,
  Drawer,
  Tooltip,
  Avatar,
  Stack,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import AddIcon from "@mui/icons-material/Add";
import CategoryIcon from "@mui/icons-material/Category";
import SearchIcon from "@mui/icons-material/Search";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSnackbar } from "../../providers/SnackbarProvider";
import * as Yup from "yup";
import { TableNodata } from "../../components/TableNodata";
import { TableLoader } from "../../components/TableLoader";
import { TruncatedText } from "../../components/TruncatedText";
import { OverAllLoader } from "../../components/OverAllLoader";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate, useLocation } from "react-router-dom";
import CustomPagination from "../../components/CustomPagination";
import { Close } from "@mui/icons-material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import FilterListIcon from "@mui/icons-material/FilterList";
import useDebounce from "../../hooks/useDebounce";
// import api from "../../api/client";
import { useChangeableItems, getLabelByKey } from "../../store/useDynamicLabel";

const Category = () => {
  const changeableItems = useChangeableItems();
  const getLabel = (itemKey) => getLabelByKey(changeableItems, itemKey);
  // Plural for "All ..." placeholders: Subject -> Subjects, Skills stays Skills, Job Role -> Job Roles
  const getPluralLabel = (itemKey) => {
    const label = getLabel(itemKey);
    return /s$/i.test(label) ? label : `${label}s`;
  };

  const tableDataCache = useRef({});

  // State
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [categoryId, setCategoryId] = useState(null);
  const [overAllLoading, setOverAllLoading] = useState(false);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const [showTable, setShowTable] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [categories, setCategories] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [selectedInstitute, setSelectedInstitute] = useState(null);
  const [selectedInstituteName, setSelectedInstituteName] = useState(null);
  const [appliedInstitute, setAppliedInstitute] = useState(null);
  const readSavedProgram = () => {
    try {
      return JSON.parse(localStorage.getItem("applyProgramCategory")) || null;
    } catch {
      return null;
    }
  };
  const [filterProgramsList, setFilterProgramsList] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState(readSavedProgram);
  const [appliedProgram, setAppliedProgram] = useState(readSavedProgram);
  const [selectedStatus, setSelectedStatus] = useState(localStorage.getItem("applyStatusCategory") || null);
  const [appliedStatus, setAppliedStatus] = useState(localStorage.getItem("applyStatusCategory") || null);
  const formatStatus = (value) => (value === "ACTIVE" ? "Active" : value === "INACTIVE" ? "Inactive" : "");
  const formatProgram = (option) => {
    if (!option) return "";
    const label = option.display_name || option.program_name || "";
    return option.program_code ? `[${option.program_code}] ${label}` : label;
  };
  const [page, setPage] = useState(+localStorage.getItem("currentPage") || 0);
  const [rowsPerPage, setRowsPerPage] = useState(
    +localStorage.getItem("rowsPerPage") || 10
  );
  const [search, setSearch] = useState(localStorage.getItem("searchvalue") || "");
  const debouncedSearch = useDebounce(search)
  const [instituteNames, setInstituteNames] = useState([]);
  const [addCategory, setAddCategory] = useState(true);
  const { showSnackbar } = useSnackbar();
  const [selectedInstitutes, setSelectedInstitutes] = useState([]);
  const [count, setCount] = useState(0);
  const [editCategoryId, setEditCategoryId] = useState(null);
  const statuses = ["ACTIVE", "INACTIVE"];
  const [loading, setLoading] = useState(false);
  const [trainersList, setTrainersList] = useState([]);
  const [selectedTrainers, setSelectedTrainers] = useState([]);
  const [trainerOptions, setTrainerOptions] = useState([]);
  const [programsList, setProgramsList] = useState([]);

  // Get current user role
  const userRole = localStorage.getItem("role");
  const isInstituteAdmin = userRole === "INSTITUTE_ADMIN";
  const isSuperAdmin = userRole === "SUPER_ADMIN";

  const schema = Yup.object().shape({
    category: Yup.string()
      .trim()
      .required(`${getLabel('SUBJECT')} name is required.`)
      .test(
        "not-only-numbers",
        `${getLabel('SUBJECT')} name cannot contain only numbers.`,
        (value) => !value || !/^\d+$/.test(value)
      )
      .test(
        "not-only-special-characters",
        `${getLabel('SUBJECT')} name cannot contain only special characters.`,
        (value) => !value || /[A-Za-z0-9]/.test(value)
      )
      .min(2, `${getLabel('SUBJECT')} name must be at least 2 characters long.`)
      .max(100, `${getLabel('SUBJECT')} name cannot exceed 100 characters.`),
    program_id: Yup.number().required(`${getLabel('PROGRAMS')} is required`).typeError(`${getLabel('PROGRAMS')} is required`),
    category_outcome: Yup.string()
      .trim()
      .required(`${getLabel('SUBJECT_OUTCOME')} is required.`)
      .min(3, `${getLabel('SUBJECT_OUTCOME')} must be at least 3 characters long.`),
    category_code: Yup.string()
      .transform((value) => (typeof value === "string" ? value.trim().replace(/\s+/g, " ") : value))
      .required(`${getLabel('SUBJECT_CODE')} is required.`)
      .test(
        "not-only-numbers",
        `${getLabel('SUBJECT_CODE')} cannot contain only numbers.`,
        (value) => !value || !/^\d+$/.test(value)
      )
      .test(
        "not-only-special-characters",
        `${getLabel('SUBJECT_CODE')} cannot contain only special characters.`,
        (value) => !value || /[A-Za-z0-9]/.test(value)
      )
      .min(3, `${getLabel('SUBJECT_CODE')} must be at least 3 characters long.`)
      .max(50, "Max 50 characters"),
    institute_id: isInstituteAdmin
      ? Yup.mixed().notRequired()
      : Yup.number()
        .typeError(`${getLabel('INSTITUTE')} is required`)
        .required(`${getLabel('INSTITUTE')} is required`),
  });

  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      category: "",
      // institute: [],
      status: "ACTIVE",
      category_outcome: "",
      program_id: null,
      category_code: "",
      institute_id: null,
    },
  });

  const handleAdd = () => {
    setAddCategory(true);
    setEditCategoryId(null);
    reset({
      category: "",
      assignTrainer: [],
      category_outcome: "",
      program_id: null,
      category_code: "",
      institute_id: null,
      // institute: []
    });
    setSelectedInstitutes([]);
    setSelectedTrainers([]);
    trainerList();
    setOpenForm(true);
  };

  const handleEdit = (rowOrId) => {
    // Accept either the full list-row object or just the category_id.
    // The list-row carries institute_id which ViewCategoryByID may not return.
    const isObject = rowOrId && typeof rowOrId === "object";
    const categoryId = isObject ? rowOrId.category_id : rowOrId;
    const listRow = isObject ? rowOrId : null;

    setAddCategory(false);
    setEditCategoryId(categoryId);

    const payload = { category_id: categoryId };

    setOverAllLoading(true);
    api
      .post("ViewCategoryByID", payload)
      .then((res) => {
        if (res?.data?.status === "success") {
          const categoryData = res.data.data;
          const trainerIds = categoryData.assignedTrainersIds || [];
          const trainerNames = categoryData.assignedTrainersName || [];

          // Map trainer IDs and names to trainer objects
          const trainers = trainerIds.map((id, index) => ({
            trainer_id: id,
            name: trainerNames[index] || "",
          }));

          // Fall back to list-row institute_id if the view endpoint omits it
          const resolvedInstituteId =
            categoryData.institute_id ?? listRow?.institute_id ?? null;

          reset({
            category: categoryData.category_name,
            assignTrainer: trainerIds,
            // institute: categoryData.institute_id,
            status: categoryData.status,
            category_outcome: categoryData.category_outcome || "",
            program_id: categoryData.program_id || null,
            category_code: categoryData.category_code || "",
            institute_id: resolvedInstituteId,
          });

          setSelectedInstitutes(resolvedInstituteId ? [resolvedInstituteId] : []);
          setSelectedTrainers(trainers);
          trainerList();
          setOpenForm(true);
        } else {
          showSnackbar("error", res?.data?.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching category:", error);
        showSnackbar("error", error?.response?.data?.message || error?.message || "Failed to fetch subject details.");
      })
      .finally(() => {
        setOverAllLoading(false);
      });
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    reset();
  };

  const handleApplyInstitute = () => {
    tableDataCache.current = {};
    setPage(0);
    setAppliedInstitute(selectedInstituteName);
    localStorage.setItem("applyInstituteCategory", selectedInstituteName);
    localStorage.setItem("applyInstituteCategoryId", selectedInstitute);
    setAppliedProgram(selectedProgram);
    setAppliedStatus(selectedStatus);
    if (selectedProgram) {
      localStorage.setItem("applyProgramCategory", JSON.stringify(selectedProgram));
    } else {
      localStorage.removeItem("applyProgramCategory");
    }
    if (selectedStatus) {
      localStorage.setItem("applyStatusCategory", selectedStatus);
    } else {
      localStorage.removeItem("applyStatusCategory");
    }
    setOpenDrawer(false);
  };

  const handleClickClear = () => {
    tableDataCache.current = {};
    setSelectedInstitute(null);
    setSelectedInstituteName(null);
    setAppliedInstitute(null);
    localStorage.removeItem("applyInstituteCategory");
    localStorage.removeItem("applyInstituteCategoryId");
    setSelectedProgram(null);
    setAppliedProgram(null);
    setSelectedStatus(null);
    setAppliedStatus(null);
    localStorage.removeItem("applyProgramCategory");
    localStorage.removeItem("applyStatusCategory");
    setPage(0);
  };

  const tableHeaders = useMemo(
    () => [
      { name: "S.No", align: "center" },
      { name: `${getLabel('PROGRAM_CODE')} / ${getLabel('PROGRAMS')}`, align: "left" },
      { name: `${getLabel('SUBJECT_CODE')} / ${getLabel('SUBJECT')}`, align: "left" },
      { name: `Assigned ${getLabel('TRAINER')}`, align: "left" },
      ...(isSuperAdmin ? [{ name: getLabel('INSTITUTE'), align: "left" }] : []),
      { name: "Status", align: "left" },
      { name: "Actions", align: "left" },
    ],
    [changeableItems]
  );

  const startIndex = useMemo(() => {
    return page * rowsPerPage;
  }, [page, rowsPerPage]);

  const statusStyles = useMemo(
    () => ({
      ACTIVE: {
        bg: "#d4edda",
        color: "#155724",
      },
      INACTIVE: {
        bg: "#f8d7da",
        color: "#721c24",
      },
    }),
    []
  );

  const onSubmit = async (data) => {
    setOverAllLoading(true);
    try {
      // Institute Admin uses their JWT institute_id; Super Admin picks from dropdown
      const userStr = localStorage.getItem("userData");
      const user = userStr ? JSON.parse(userStr) : null;
      const institute_id = isInstituteAdmin
        ? user?.institute_id || null
        : data.institute_id;

      const payload = {
        category: data.category,
        institute_id: institute_id,
        status: "ACTIVE",
        trainersIds: isInstituteAdmin ? (data.assignTrainer || []) : null,
        category_outcome: data.category_outcome || "",
        program_id: data.program_id || 0,
        ...(data.category_code ? { category_code: data.category_code } : {}),
      };

      const updatePayload = {
        category_id: editCategoryId,
        institute_id: institute_id,
        category: data.category,
        status: data.status,
        trainersIds: isInstituteAdmin ? (data.assignTrainer || []) : null,
        category_outcome: data.category_outcome || "",
        program_id: data.program_id || 0,
        ...(data.category_code ? { category_code: data.category_code } : {}),
      };

      if (editCategoryId !== null) {
        const res = await api.post("UpdateCategoryByID", updatePayload);
        if (res?.data?.status === "success") {
          tableDataCache.current = {};
          showSnackbar("success", res?.data?.message);
          setOpenForm(false);
          listCategory();
        } else {
          showSnackbar("error", res?.data?.message);
        }
      } else {
        const res = await api.post("CreateCategory", payload);
        if (res?.data?.status === "success") {
          tableDataCache.current = {};
          setOpenForm(false);
          listCategory();
          showSnackbar("success", res?.data?.message);
        } else {
          showSnackbar("error", res?.data?.message);
        }
      }
    } catch (e) {
      console.log("Error:", e);
      showSnackbar("error", e?.response?.data?.message || e?.message || "Something went wrong. Please try again.");
    } finally {
      setOverAllLoading(false);
    }
  };

  const instituteDropDown = async () => {
    setOverAllLoading(true);
    try {
      const { data } = await api.post("ListInstituteNames");
      setInstituteNames(data?.data ?? []);
    } catch (error) {
      console.error("Error fetching institutes:", error);
    } finally {
      setOverAllLoading(false);
    }
  };

  // Super Admin passes the institute picked in the popup; Institute Admin uses their own
  const fetchProgramsDropdown = async (selectedInstituteId = null, isIgnored = () => false) => {
    try {
      const userStr = localStorage.getItem("userData");
      const user = userStr ? JSON.parse(userStr) : null;
      let institute_id = user?.role === "INSTITUTE_ADMIN" ? user.institute_id : selectedInstituteId;

      const payload = {};
      if (institute_id) {
        payload.institute_id = institute_id;
      }

      const res = await api.post("GetProgramsDropdown", payload);
      if (isIgnored()) return;
      if (res?.data?.status === "success") {
        setProgramsList(res?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching programs:", error);
    }
  };

  const selectedFormInstituteId = watch("institute_id");
  useEffect(() => {
    if (isInstituteAdmin) return;
    let ignore = false;
    setProgramsList([]);
    if (selectedFormInstituteId) {
      fetchProgramsDropdown(selectedFormInstituteId, () => ignore);
    }
    return () => {
      ignore = true;
    };
  }, [selectedFormInstituteId]);

  const trainerList = async () => {
    try {
      const userStr = localStorage.getItem("userData");
      const user = userStr ? JSON.parse(userStr) : null;
      const institute_id = user?.role === "INSTITUTE_ADMIN" ? user.institute_id : 0;

      const payload = {
        institute_id: institute_id,
      };
      const res = await api.post("/ListTrainersForFilter", payload);
      if (res?.data?.status === "success") {
        const list = res?.data?.data || [];
        setTrainersList(list);

        // The logged-in institute admin is injected at index 0 — they must
        // always be assigned and cannot be unchecked. Pre-select them.
        const mandatoryId = list[0]?.trainer_id;
        if (mandatoryId != null) {
          const current = getValues("assignTrainer") || [];
          if (!current.includes(mandatoryId)) {
            setValue("assignTrainer", [mandatoryId, ...current]);
            setSelectedTrainers(
              list.filter((t) => [mandatoryId, ...current].includes(t.trainer_id))
            );
          }
        }
      }
    } catch (error) {
      console.log("Error :", error);
      showSnackbar("error", error?.response?.data?.message || error?.message || "Failed to fetch trainers list. Please try again.");
    }
  };

  const selectedProgramId = watch("program_id");
  useEffect(() => {
    if (!isInstituteAdmin) return;
    let ignore = false;
    const mandatory = trainersList[0] || null;

    const applyOptions = (programTrainers) => {
      const options = mandatory
        ? [mandatory, ...programTrainers.filter((t) => t.trainer_id !== mandatory.trainer_id)]
        : programTrainers;
      setTrainerOptions(options);
      // Drop selected trainers that are not in this program (the admin always stays)
      const allowed = options.map((t) => t.trainer_id);
      const kept = (getValues("assignTrainer") || []).filter((id) => allowed.includes(id));
      setValue("assignTrainer", mandatory && !kept.includes(mandatory.trainer_id) ? [mandatory.trainer_id, ...kept] : kept);
    };

    if (!selectedProgramId) {
      applyOptions([]);
      return;
    }
    api
      .post("/GetTrainersByProgram", { program_id: selectedProgramId })
      .then((res) => {
        if (ignore) return;
        const list = res?.data?.status === "success" ? res?.data?.data || [] : [];
        applyOptions(list.map((t) => ({ trainer_id: t.user_id, name: t.trainer_name })));
      })
      .catch((error) => {
        if (ignore) return;
        console.log("Error :", error);
        applyOptions([]);
      });
    return () => {
      ignore = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProgramId, trainersList]);

  const listCategory = async () => {
    setLoading(true);

    const caheKey = `page_${page}_size_${rowsPerPage}_search_${debouncedSearch}_appliedInstitute_${appliedInstitute}_program_${appliedProgram?.program_id || ""}_status_${appliedStatus || ""}`;

    if (tableDataCache?.current[caheKey]) {
      const cached = tableDataCache?.current[caheKey];
      setCategories(cached?.data);
      setCount(cached?.total);
      setLoading(false);
      return;
    }

    try {
      // Get institute_id from localStorage for institute admin, null for super admin
      const userStr = localStorage.getItem("userData");
      const user = userStr ? JSON.parse(userStr) : null;
      let institute_id = user?.role === "INSTITUTE_ADMIN" ? user.institute_id : null;

      // If SUPER_ADMIN and selectedInstitute is set, use it
      if (user?.role === "SUPER_ADMIN" && selectedInstitute) {
        institute_id = selectedInstitute;
      }

      const payload = {
        page: page || 0,
        size: rowsPerPage || 5,
        search_key: debouncedSearch || "",
        institute_id: institute_id,
        ...(appliedProgram?.program_id ? { program_id: appliedProgram.program_id } : {}),
        ...(appliedStatus ? { status: appliedStatus } : {}),
      };
      const res = await api.post("ListCategories", payload);
      if (res?.data?.status === "success") {
        const data = res?.data?.data;
        const total = res?.data?.total;

        tableDataCache.current[caheKey] = {
          data,
          total,
        };
        setCategories(res.data.data);
        setCount(res?.data?.total);
        setLoading(false);
      } else {
        showSnackbar("error", "Failed to fetch the list. Please try again.");
        setLoading(false);
      }
    } catch (error) {
      console.log("Error :", error);
      showSnackbar("error", error?.response?.data?.message || error?.message || "Failed to fetch the list. Please try again.");
      setLoading(false);
    }
  };

  useEffect(() => {
    instituteDropDown();
    if (isInstituteAdmin) fetchProgramsDropdown();
    // Load applied institute from localStorage on mount
    const savedAppliedInstitute = localStorage.getItem("applyInstituteCategory");
    const savedAppliedInstituteId = localStorage.getItem("applyInstituteCategoryId");
    if (savedAppliedInstitute) {
      setAppliedInstitute(savedAppliedInstitute);
      setSelectedInstituteName(savedAppliedInstitute);
      setSelectedInstitute(savedAppliedInstituteId ? parseInt(savedAppliedInstituteId) : null);
    }
  }, []);

  useEffect(() => {
    listCategory();
  }, [page, rowsPerPage, debouncedSearch, appliedInstitute, appliedProgram, appliedStatus]);

  useEffect(() => {
    if (!openDrawer) return;
    let ignore = false;
    api
      .post("GetProgramsDropdown", selectedInstitute ? { institute_id: selectedInstitute } : {})
      .then((res) => {
        if (!ignore && res?.data?.status === "success") setFilterProgramsList(res?.data?.data || []);
      })
      .catch((error) => console.error("Error fetching programs:", error));
    return () => {
      ignore = true;
    };
  }, [openDrawer, selectedInstitute]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowTable(true);
    }, 200); // 0.2 sec delay

    return () => clearTimeout(timer);
  }, []);

  return (
    <Box sx={{ minHeight: "100vh", p: 1 }}>
      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        PaperProps={{
          sx: {
            width: 320,
            p: 3,
            display: "flex",
            flexDirection: "column",
            gap: 2.5,
            height: "100vh",
            borderRadius: "12px 0 0 12px",
          },
        }}
      >
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center" gap={1}>
            <FilterListIcon color="primary" />
            <Typography variant="h6" fontWeight={600} color="primary">
              Filters
            </Typography>
          </Box>
          <IconButton size="small" onClick={() => setOpenDrawer(false)}>
            <Close />
          </IconButton>
        </Box>

        <Divider />

        {localStorage.getItem("role") === "SUPER_ADMIN" && (
          <Box display="flex" flexDirection="column" gap={0.8}>
            <Typography variant="subtitle2" fontWeight={600}>
              {`${getLabel('INSTITUTE')}`}
            </Typography>
            <Autocomplete
              size="small"
              options={instituteNames}
              getOptionLabel={(option) => option?.name || ""}
              value={
                instituteNames.find(
                  (inst) => inst.institute_id === selectedInstitute
                ) || null
              }
              onChange={(event, newValue) => {
                setSelectedInstitute(newValue ? newValue.institute_id : null);
                setSelectedInstituteName(newValue ? newValue.name : null);
                setSelectedProgram(null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="All Institutes"
                  fullWidth
                  variant="outlined"
                />
              )}
            />
          </Box>
        )}

        <Box display="flex" flexDirection="column" gap={0.8}>
          <Typography variant="subtitle2" fontWeight={600}>
            {getLabel('PROGRAMS')}
          </Typography>
          <Autocomplete
            size="small"
            options={filterProgramsList}
            getOptionLabel={formatProgram}
            isOptionEqualToValue={(o, v) => o?.program_id === v?.program_id}
            value={selectedProgram}
            onChange={(_, newValue) => setSelectedProgram(newValue)}
            renderOption={(props, option) => (
              <li {...props} key={option.program_id}>
                {formatProgram(option)}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={`All ${getPluralLabel('PROGRAMS')}`}
                fullWidth
                variant="outlined"
              />
            )}
          />
        </Box>

        <Box display="flex" flexDirection="column" gap={0.8}>
          <Typography variant="subtitle2" fontWeight={600}>
            Status
          </Typography>
          <Autocomplete
            size="small"
            options={statuses}
            getOptionLabel={formatStatus}
            value={selectedStatus}
            onChange={(_, newValue) => setSelectedStatus(newValue)}
            renderInput={(params) => (
              <TextField {...params} placeholder="All Statuses" fullWidth variant="outlined" />
            )}
          />
        </Box>

        <Button
          variant="contained"
          color="primary"
          fullWidth
          className="customButton"
          onClick={handleApplyInstitute}
        >
          Apply Filters
        </Button>
      </Drawer>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
        // borderBottom={"1px solid #828487"}
        sx={{
          pb: 2,
        }}
      >
        <Grid
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 0.5,
            alignItems: "center",
          }}
        >
          <Box className="icon-box">
            <CategoryIcon className="iconHeading" />
          </Box>
          <Typography sx={{ fontSize: { xs: 20, sm: 28 }, fontWeight: 700, color: "#0a0a0a" }}>
            {getLabel("SUBJECT")}
          </Typography>
        </Grid>
        <Box display="flex" gap={4} alignItems="center">
          <TextField
            value={search}
            onChange={(e) => (setPage(0), setSearch(e.target.value), localStorage.setItem("searchvalue", e.target.value))}
            size="small"
            variant="outlined"
            placeholder={`Search by ${getLabel("SUBJECT")}`}
            className="custom-search-field"
            InputProps={{
              startAdornment: (
                <InputAdornment
                  position="start"
                  sx={{ marginLeft: "6px", marginRight: "2px" }}
                >
                  <SearchIcon sx={{ color: "inherit", fontSize: "18px" }} />
                </InputAdornment>
              ),
            }}
          />
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleAdd}
            className="gradient-button"
          >
            Add {getLabel("SUBJECT")}
          </Button>
        </Box>
      </Box>

      {/* Table */}
      <TableContainer
        component={Paper}
        sx={{
          opacity: showTable ? 1 : 0,
          transform: showTable ? "translateY(0)" : "translateY(40px)",
          transition: "opacity 0.5s ease, transform 0.5s ease",
        }}
      >
        <Table>
          {/* TABLE HEADER */}
          <TableHead>
            {localStorage.getItem("role") === "SUPER_ADMIN" && (
              <TableRow>
                <TableCell colSpan={tableHeaders.length}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                      {appliedInstitute && (
                        <Box className="filter-chip">
                          <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                            {appliedInstitute}
                          </Typography>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setAppliedInstitute(null);
                              setSelectedInstituteName(null);
                              setSelectedInstitute(null);
                              setPage(0);
                              localStorage.removeItem("applyInstituteCategory");
                              localStorage.removeItem("applyInstituteCategoryId");
                            }}
                            sx={{ ml: 0.5 }}
                          >
                            <Close sx={{ fontSize: "14px" }} />
                          </IconButton>
                        </Box>
                      )}
                      {appliedProgram && (
                        <Box className="filter-chip">
                          <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                            {formatProgram(appliedProgram)}
                          </Typography>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setAppliedProgram(null);
                              setSelectedProgram(null);
                              setPage(0);
                              localStorage.removeItem("applyProgramCategory");
                            }}
                            sx={{ ml: 0.5 }}
                          >
                            <Close sx={{ fontSize: "14px" }} />
                          </IconButton>
                        </Box>
                      )}
                      {appliedStatus && (
                        <Box className="filter-chip">
                          <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                            {formatStatus(appliedStatus)}
                          </Typography>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setAppliedStatus(null);
                              setSelectedStatus(null);
                              setPage(0);
                              localStorage.removeItem("applyStatusCategory");
                            }}
                            sx={{ ml: 0.5 }}
                          >
                            <Close sx={{ fontSize: "14px" }} />
                          </IconButton>
                        </Box>
                      )}
                    </Box>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <IconButton
                        onClick={() => setOpenDrawer(true)}
                        color="primary"
                        className="more-filter-btn"
                      >
                        <FilterListIcon />
                        <Typography className="more-filter-text">
                          More filter
                        </Typography>
                      </IconButton>

                      {(appliedInstitute !== null || appliedProgram || appliedStatus) && (
                        <Button
                          variant="outlined"
                          className="clear-filter-btn"
                          onClick={handleClickClear}
                        >
                          Clear Filter
                        </Button>
                      )}
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
            )}
            <TableRow>
              {tableHeaders.map((header) => (
                <TableCell
                  align={header?.align}
                  key={header}
                  className="tableHeader"
                >
                  <b>{header.name}</b>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          {/* LOADER */}
          {loading ? (
            <TableBody>
              <TableRow>
                <TableCell colSpan={tableHeaders.length} align="center">
                  <TableLoader message="Fetching subjects..." />
                </TableCell>
              </TableRow>
            </TableBody>
          ) : (
            <TableBody className="tablebody">
              {/* TABLE ROWS */}
              {categories.map((item, index) => (
                <TableRow
                  key={item.category_id}
                  sx={{
                    backgroundColor: index % 2 === 1 ? "#FAFAFA" : "inherit",
                    "&:hover": { backgroundColor: "#f1f1f1" },
                  }}
                >
                  <TableCell align="center">{startIndex + index + 1}</TableCell>

                  {/* PROGRAM: code + name */}
                  <TableCell sx={{ maxWidth: '200px' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                      {item.program_code && (
                        <Typography sx={{ fontWeight: 700, fontSize: '12px', color: '#1c97e3', letterSpacing: '0.3px' }}>
                          {item.program_code}
                        </Typography>
                      )}
                      <Typography sx={{ fontWeight: 600, fontSize: '13px', color: '#1a1a1a', wordBreak: 'break-word', lineHeight: 1.3 }}>
                        {item.program_name || "-"}
                      </Typography>
                    </Box>
                  </TableCell>

                  {/* SUBJECT: code + name */}
                  <TableCell sx={{ maxWidth: '300px' }}>
                    <Box
                      sx={{ display: 'flex', flexDirection: 'column', gap: 0.2, cursor: 'pointer' }}
                      onClick={() =>
                        navigate("/subcategory", {
                          state: {
                            categoryName: item.category_name,
                            categoryId: item.category_id,
                          },
                        })
                      }
                    >
                      {item.category_code && (
                        <Typography sx={{ fontWeight: 700, fontSize: '12px', color: '#1c97e3', letterSpacing: '0.3px' }}>
                          {item.category_code}
                        </Typography>
                      )}
                      <Typography sx={{ fontWeight: 600, fontSize: '13px', color: '#1a1a1a', wordBreak: 'break-word', lineHeight: 1.3, '&:hover': { color: '#1c97e3' } }}>
                        {item.category_name}
                      </Typography>
                    </Box>
                  </TableCell>

                  {/* ASSIGNED TRAINERS */}
                  <TableCell
                    sx={{
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                  >
                    {item.assignedTrainersName && item.assignedTrainersName.length > 0 ? (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ display: "flex" }}>
                          {item.assignedTrainersName.slice(0, 4).map((name, index) => (
                            <Tooltip
                              key={index}
                              arrow
                              title={
                                <Stack
                                  direction="row"
                                  spacing={1}
                                  alignItems="center"
                                  sx={{
                                    background:
                                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                    borderRadius: 2,
                                    p: "6px 10px",
                                    boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                                  }}
                                >
                                  <Avatar
                                    sx={{
                                      width: 28,
                                      height: 28,
                                      fontSize: 13,
                                      background:
                                        "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
                                      color: "#fff",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {name.charAt(0).toUpperCase()}
                                  </Avatar>
                                  <Typography
                                    sx={{
                                      color: "#fff",
                                      fontSize: 13,
                                      fontWeight: 500,
                                      textShadow:
                                        "0px 1px 2px rgba(0,0,0,0.4)",
                                    }}
                                  >
                                    {name}
                                  </Typography>
                                </Stack>
                              }
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    background: "transparent",
                                    p: 0,
                                  },
                                },
                                arrow: {
                                  sx: { color: "transparent" },
                                },
                              }}
                            >
                              <Avatar
                                sx={{
                                  width: 30,
                                  height: 30,
                                  fontSize: 13,
                                  background:
                                    "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
                                  color: "#fff",
                                  fontWeight: 600,
                                  boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                                  cursor: "pointer",
                                  transition: "transform 0.2s ease",
                                  "&:hover": {
                                    transform: "scale(1.1)",
                                    zIndex: 5,
                                  },
                                  ml: index === 0 ? 0 : -1.0,
                                  border: "2px solid #fff",
                                }}
                              >
                                {name.charAt(0).toUpperCase()}
                              </Avatar>
                            </Tooltip>
                          ))}
                          {item.assignedTrainersName.length > 4 && (
                            <Tooltip
                              arrow
                              title={item.assignedTrainersName.slice(4).join(", ")}
                            >
                              <Avatar
                                sx={{
                                  width: 30,
                                  height: 30,
                                  fontSize: 12,
                                  backgroundColor: "#e2e8f0",
                                  color: "#334155",
                                  fontWeight: 600,
                                  boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                                  cursor: "pointer",
                                  ml: -1.0,
                                  border: "2px solid #fff",
                                }}
                              >
                                +{item.assignedTrainersName.length - 4}
                              </Avatar>
                            </Tooltip>
                          )}
                        </Box>
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 13,
                            fontWeight: 600,
                            color: "#888",
                            fontStyle: "italic",
                          }}
                        >
                          Not Assigned Yet
                        </Typography>
                      </Box>
                    )}
                  </TableCell>

                  {isSuperAdmin && (
                    <TableCell>
                      <TruncatedText text={item.institute_name || "-"} maxWidth={200} />
                    </TableCell>
                  )}

                  {/* STATUS */}
                  <TableCell
                    align="left"
                    sx={{
                      padding: "10px 10px",
                      whiteSpace: "nowrap",
                      width: "1%",
                    }}
                  >
                    <Box
                      sx={{
                        display: "inline-block",
                        px: 2,
                        py: 0.5,
                        borderRadius: "12px",
                        fontWeight: "bold",
                        fontSize: "12px",
                        backgroundColor:
                          statusStyles[item.status]?.bg || "#f1f1f1",
                        color: statusStyles[item.status]?.color || "#333",
                        textAlign: "center",
                      }}
                    >
                      {item.status}
                    </Box>
                  </TableCell>

                  {/* ACTIONS */}
                  <TableCell
                    align="left"
                    sx={{
                      padding: "10px 10px",
                      whiteSpace: "nowrap",
                      width: "1%",
                    }}
                  >
                    <Box
                      display="flex"
                      justifyContent="left"
                      alignItems="center"
                      gap={2}
                    >
                      {/* View - Overview */}
                      <IconButton
                        size="small"
                        onClick={() => {
                          navigate("/category/view", {
                            state: {
                              categoryData: item,
                            },
                          });
                        }}
                      >
                        <VisibilityIcon color="primary" />
                        <Typography sx={{ fontSize: "12px" }} color="primary">
                          View
                        </Typography>
                      </IconButton>

                      {/* View - Only for SUPER_ADMIN */}
                      {/* {localStorage.getItem("role") === "SUPER_ADMIN" && (
                        <IconButton
                          size="small"
                          onClick={() => {
                            navigate("/category/institutes", {
                              state: {
                                categoryId: item.category_id,
                                viewInstitute: true,
                                categoryName: item.category_name,
                              },
                            });
                            handleClose();
                          }}
                        >
                          <VisibilityIcon color="primary" />
                          <Typography sx={{ fontSize: "12px" }} color="primary">
                            See Institutes
                          </Typography>
                        </IconButton>
                      )} */}

                      {/* Edit */}
                      <IconButton
                        size="small"
                        onClick={() => {
                          handleEdit(item);
                          handleClose();
                        }}
                      >
                        <EditIcon color="primary" />
                        <Typography sx={{ fontSize: "12px" }} color="primary">
                          Edit
                        </Typography>
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}

              {/* FULL-WIDTH PAGINATION */}
              {((page === 0 && categories?.length > rowsPerPage - 1) ||
                page !== 0) && (
                  <CustomPagination
                    page={page}
                    setPage={setPage}
                    count={count}
                    rowsPerPage={rowsPerPage}
                    colSpan={tableHeaders.length}
                  />
                )}

              {/* NO DATA */}
              {categories?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={tableHeaders.length} align="center">
                    <TableNodata />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          )}
        </Table>
      </TableContainer>

      {/*  Dialog */}
      <Dialog
        open={openForm}
        PaperProps={{
          sx: { width: "500px", borderRadius: "12px", p: 2 },
        }}
      >
        <Box
          sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          <CategoryIcon
            sx={{
              backgroundColor: "#1976d2",
              color: "white",
              fontSize: "30px",
              top: -20,
              borderRadius: "50%",
              padding: "5px",
            }}
          />
          <DialogTitle
            sx={{ fontWeight: 700, color: "#1976d2", padding: "5px" }}
          >
            {addCategory ? `Add ${getLabel('SUBJECT')}` : `Update ${getLabel('SUBJECT')}`}
          </DialogTitle>
        </Box>
        <Divider
          sx={{ mt: 2, borderColor: "black", borderBottomWidth: 1, mx: 0 }}
        />
        <DialogContent>
          <form onSubmit={handleSubmit(onSubmit)} sx={{ mt: 1 }}>
            {/* 1. Assign Institute — Super Admin only */}
            {!isInstituteAdmin && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Typography sx={{ fontWeight: "bold", mb: 0.5 }}>
                    {`Assign ${getLabel('INSTITUTE')}`} <span style={{ color: "red" }}>*</span>
                  </Typography>
                </Box>
                <Controller
                  name="institute_id"
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      options={instituteNames}
                      getOptionLabel={(option) => option?.name || ""}
                      isOptionEqualToValue={(o, v) =>
                        o?.institute_id === v?.institute_id
                      }
                      value={
                        instituteNames.find(
                          (inst) => inst.institute_id === field.value
                        ) || null
                      }
                      onChange={(_, newValue) => {
                        field.onChange(newValue ? newValue.institute_id : null);
                        setValue("program_id", null, { shouldValidate: false });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          placeholder={`Select ${getLabel('INSTITUTE')}`}
                          margin="dense"
                          sx={{ mb: 2 }}
                          error={!!errors.institute_id}
                          helperText={errors.institute_id?.message}
                        />
                      )}
                    />
                  )}
                />
              </>
            )}

            {/* 2. Program */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: "bold", mb: 0.5 }}>
                {getLabel('PROGRAMS')} <span style={{ color: "red" }}>*</span>
              </Typography>
            </Box>
            <Controller
              name="program_id"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  {...field}
                  options={programsList}
                  disabled={!isInstituteAdmin && !selectedFormInstituteId}
                  getOptionLabel={(option) => {
                    if (!option) return "";
                    const label = option.display_name || option.program_name || "";
                    return option.program_code ? `[${option.program_code}] ${label}` : label;
                  }}
                  value={
                    programsList.find((p) => p.program_id === field.value) || null
                  }
                  onChange={(e, newValue) => {
                    field.onChange(newValue ? newValue.program_id : null);
                  }}
                  renderOption={(props, option) => (
                    <li {...props} key={option.program_id}>
                      {option.program_code ? `[${option.program_code}] ` : ""}
                      {option.display_name || option.program_name}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      placeholder={
                        !isInstituteAdmin && !selectedFormInstituteId
                          ? `Select ${getLabel('INSTITUTE')} first`
                          : `Select ${getLabel('PROGRAMS')}`
                      }
                      margin="dense"
                      sx={{ mb: 2 }}
                      error={!!errors.program_id}
                      helperText={errors.program_id?.message}
                    />
                  )}
                />
              )}
            />

            {/* 3. Subject */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                mt: 1,
              }}
            >
              <Typography sx={{ fontWeight: "bold", mb: 0.5 }}>
                {getLabel('SUBJECT')} <span style={{ color: "red" }}>*</span>
              </Typography>
            </Box>
            <Controller
              name="category"
              control={control}
              render={({ field }) => (
                <TextField
                  sx={{ mb: 2 }}
                  {...field}
                  fullWidth
                  placeholder={`Enter ${getLabel('SUBJECT')}`}
                  margin="dense"
                  error={!!errors.category}
                  helperText={errors.category?.message}
                  inputProps={{
                    style: { textTransform: 'uppercase' }
                  }}
                  onChange={(e) => {
                    const uppercaseValue = e.target.value.toUpperCase();
                    field.onChange(uppercaseValue);
                  }}
                />
              )}
            />

            {/* 4. Subject Code */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: "bold", mb: 0.5 }}>
                {getLabel('SUBJECT_CODE')} <span style={{ color: "red" }}>*</span>
              </Typography>
            </Box>
            <Controller
              name="category_code"
              control={control}
              render={({ field }) => (
                <TextField
                  sx={{ mb: 2 }}
                  {...field}
                  fullWidth
                  placeholder="e.g. JAVA01 (max 50 chars)"
                  margin="dense"
                  inputProps={{ maxLength: 50 }}
                  error={!!errors.category_code}
                  helperText={errors.category_code?.message}
                />
              )}
            />

            {/* 5. Subject Outcome */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: "bold", mb: 0.5 }}>
                {getLabel('SUBJECT_OUTCOME')} <span style={{ color: "red" }}>*</span>
              </Typography>
            </Box>
            <Controller
              name="category_outcome"
              control={control}
              render={({ field }) => (
                <TextField
                  sx={{ mb: 2 }}
                  {...field}
                  fullWidth
                  placeholder={`Enter ${getLabel('SUBJECT_OUTCOME')}`}
                  margin="dense"
                  multiline
                  minRows={3}
                  error={!!errors.category_outcome}
                  helperText={errors.category_outcome?.message}
                />
              )}
            />

            {/* 6. Assign Trainers - Only for Institute Admin */}
            {isInstituteAdmin && (
              <Grid sx={{ width: "100%" }}>
                <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                  Assign {getLabel('TRAINER')}
                </Typography>

                <Controller
                  name="assignTrainer"
                  control={control}
                  defaultValue={[]}
                  render={({ field }) => {
                    // Index 0 = injected institute admin — mandatory, cannot be removed.
                    const mandatoryTrainerId = trainersList[0]?.trainer_id;
                    return (
                      <Autocomplete
                        multiple
                        disableCloseOnSelect
                        options={trainerOptions}
                        getOptionLabel={(option) => option.name || ""}
                        value={trainerOptions.filter((t) =>
                          field.value?.includes(t.trainer_id)
                        )}
                        onChange={(_, selectedValues) => {
                          let selectedIds = selectedValues.map((v) => v.trainer_id);
                          // Keep the mandatory admin even if the user tries to remove them.
                          if (
                            mandatoryTrainerId != null &&
                            !selectedIds.includes(mandatoryTrainerId)
                          ) {
                            selectedIds = [mandatoryTrainerId, ...selectedIds];
                          }
                          field.onChange(selectedIds);
                          setSelectedTrainers(
                            trainerOptions.filter((t) => selectedIds.includes(t.trainer_id))
                          );
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option.trainer_id === value.trainer_id
                        }
                        renderOption={(props, option, { selected }) => {
                          const isMandatory = option.trainer_id === mandatoryTrainerId;
                          return (
                            <li
                              {...props}
                              aria-disabled={isMandatory}
                              style={{ ...(props.style || {}), ...(isMandatory ? { pointerEvents: "none" } : {}) }}
                            >
                              <Checkbox
                                checked={selected || isMandatory}
                                disabled={isMandatory}
                                readOnly
                                sx={{ mr: 1 }}
                              />
                              {option.name}
                            </li>
                          );
                        }}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => {
                            const isMandatory = option.trainer_id === mandatoryTrainerId;
                            const tagProps = getTagProps({ index });
                            const { key, ...rest } = tagProps;
                            return (
                              <Chip
                                {...rest}
                                key={option.trainer_id}
                                label={option.name}
                                size="small"
                                onDelete={isMandatory ? undefined : tagProps.onDelete}
                              />
                            );
                          })
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={`Select ${getLabel('TRAINER')}s`}
                            fullWidth
                            error={!!errors.assignTrainer}
                            helperText={errors.assignTrainer?.message}
                          />
                        )}
                      />
                    );
                  }}
                />
              </Grid>
            )}

            {!addCategory && (
              <Grid sx={{ display: "flex", gap: 3 }}>
                {/* Status */}
                <Grid sx={{ width: "100%", mt: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    {watch("status") === "ACTIVE" ? (
                      <ToggleOnIcon
                        sx={{
                          color: "#1976d2",
                          fontSize: "25px",
                          mr: 1,
                        }}
                      />
                    ) : (
                      <ToggleOffIcon
                        sx={{
                          color: "grey",
                          fontSize: "25px",
                          mr: 1,
                        }}
                      />
                    )}
                    <Typography sx={{ fontWeight: "bold" }}>
                      Status <span style={{ color: "red" }}>*</span>
                    </Typography>
                  </Box>
                  <Controller
                    name="status"
                    control={control}
                    render={({ field }) => (
                      <TextField {...field} select fullWidth>
                        {/* Placeholder */}
                        <MenuItem
                          value="default"
                          disabled
                          sx={{ color: "grey" }}
                        >
                          Select Status
                        </MenuItem>

                        {/* Options */}
                        {statuses.map((status) => (
                          <MenuItem key={status} value={status}>
                            {status.charAt(0).toUpperCase() + status.slice(1)}
                          </MenuItem>
                        ))}
                      </TextField>
                    )}
                  />
                </Grid>
              </Grid>
            )}
            <DialogActions sx={{ justifyContent: "end", pb: 2, mt: 2 }}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleCloseForm}
                sx={{ textTransform: "none" }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{ textTransform: "none" }}
              >
                {addCategory === true || addCategory === "true"
                  ? "Add"
                  : "Update"}{" "}
                {getLabel('SUBJECT')}
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
      {overAllLoading && <OverAllLoader message="Saving subject..." />}
    </Box>
  );
};

export default Category;
